module.exports = __webpack_public_path__ + "img/pic-1-2.ef39ea97.jpg";